import { SubscriptionItemType, SubscriptionType } from '../common/interfaces';
var CHEGG_STUDY_PACK_STUDY_OFFER_IDS = [SubscriptionType.CHEGG_STUDY.toString(), SubscriptionType.CHEGG_STUDY_6_MONTH.toString(), SubscriptionType.CHEGG_STUDY_12_MONTH.toString()];

/**
 * Determine given offerId is Study offerId used for Study Pack
 * @param offerId
 * @returns boolean
 */
var hasCheggStudyPackStudyOfferId = function hasCheggStudyPackStudyOfferId(offerId) {
  return offerId && CHEGG_STUDY_PACK_STUDY_OFFER_IDS.includes(offerId);
};

/**
 * Determine given subscription catalog data is Chegg Study Pack subscription catalog data
 * @param subscription: SubscriptionCatalogData
 * @returns boolean
 */
export var isCSPSubscriber = function isCSPSubscriber(subscription) {
  var _subscription$offerId;
  return !!((_subscription$offerId = subscription.offerIds) !== null && _subscription$offerId !== void 0 && _subscription$offerId.some(hasCheggStudyPackStudyOfferId)) && subscription.itemType === SubscriptionItemType.RECURRING_BUNDLE_ITEM;
};

/**
 * Determine given subscription catalog data is Study V1 subscription catalog data
 * @param subscription: SubscriptionCatalogData
 * @returns boolean
 */
export var isCSv1Subscriber = function isCSv1Subscriber(subscription) {
  var _subscription$offerId2;
  return !!((_subscription$offerId2 = subscription.offerIds) !== null && _subscription$offerId2 !== void 0 && _subscription$offerId2.includes(SubscriptionType.CHEGG_STUDY)) && subscription.itemType === SubscriptionItemType.FIXED_RECURRING_ITEM;
};

/**
 * Determine given subscription catalog data is Study V2 subscription catalog data
 * @param subscription: SubscriptionCatalogData
 * @returns boolean
 */
export var isCSv2Subscriber = function isCSv2Subscriber(subscription) {
  var _subscription$offerId3;
  return !!((_subscription$offerId3 = subscription.offerIds) !== null && _subscription$offerId3 !== void 0 && _subscription$offerId3.includes(SubscriptionType.CHEGG_STUDY_V2));
};

/**
 * Determine given subscription catalog data is Math subscription catalog data
 * @param subscription: SubscriptionCatalogData
 * @returns boolean
 */
export var isMathSubscriber = function isMathSubscriber(subscription) {
  var _subscription$offerId4;
  return !!((_subscription$offerId4 = subscription.offerIds) !== null && _subscription$offerId4 !== void 0 && _subscription$offerId4.includes(SubscriptionType.CHEGG_MATH));
};

/**
 * Determine given subscription catalog data is Writings subscription catalog data
 * @param subscription: SubscriptionCatalogData
 * @returns boolean
 */
export var isWritingSubscriber = function isWritingSubscriber(subscription) {
  var _subscription$offerId5;
  return !!((_subscription$offerId5 = subscription.offerIds) !== null && _subscription$offerId5 !== void 0 && _subscription$offerId5.includes(SubscriptionType.CHEGG_WRITING));
};

/**
 * Determine given subscription catalog data is Ebook subscription catalog data
 * @param subscription: SubscriptionCatalogData
 * @returns boolean
 */
export var isEbookSubscriber = function isEbookSubscriber(subscription) {
  var _subscription$offerId6;
  return !!((_subscription$offerId6 = subscription.offerIds) !== null && _subscription$offerId6 !== void 0 && _subscription$offerId6.includes(SubscriptionType.EBOOK_SUB));
};

/**
 * function to return subscription type based on user's order line items data
 * @param order: OrderLineItems
 * @returns SubscriptionType
 */
export var getSubscriptionType = function getSubscriptionType(order) {
  var subscriptionTypeUtilMap = [{
    checkSubscriptionFun: isCSPSubscriber,
    subscriptionType: SubscriptionType.CHEGG_STUDY_PACK
  }, {
    checkSubscriptionFun: isCSv1Subscriber,
    subscriptionType: SubscriptionType.CHEGG_STUDY
  }, {
    checkSubscriptionFun: isCSv2Subscriber,
    subscriptionType: SubscriptionType.CHEGG_STUDY_V2
  }, {
    checkSubscriptionFun: isMathSubscriber,
    subscriptionType: SubscriptionType.CHEGG_MATH
  }, {
    checkSubscriptionFun: isWritingSubscriber,
    subscriptionType: SubscriptionType.CHEGG_WRITING
  }, {
    checkSubscriptionFun: isEbookSubscriber,
    subscriptionType: SubscriptionType.EBOOK_SUB
  }];
  for (var index = 0; index < subscriptionTypeUtilMap.length; index++) {
    var _order$productDetails;
    var _subscriptionTypeUtil = subscriptionTypeUtilMap[index],
      checkSubscriptionFun = _subscriptionTypeUtil.checkSubscriptionFun,
      subscriptionType = _subscriptionTypeUtil.subscriptionType;
    var catalogData = {
      offerIds: (_order$productDetails = order.productDetails) === null || _order$productDetails === void 0 ? void 0 : _order$productDetails.offerIds,
      itemType: order.itemType
    };
    if (checkSubscriptionFun(catalogData)) {
      return subscriptionType;
    }
  }
  return SubscriptionType.NON_SUBSCRIBER;
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/getSubscriptionType.js
// module id = 4126
// module chunks = 11